module.exports = __webpack_public_path__ + "static/media/DuplicateSans-Light.785a2a44.woff";